"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrostAndFireBoltAbilityHandler = exports.FrostAndFireBoltActorAbilityFactory = exports.FrostAndFireBoltAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class FrostAndFireBoltAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.FrostAndFireBolt;
        this.__typeName = "FrostAndFireBolt";
    }
}
exports.FrostAndFireBoltAbilityArgs = FrostAndFireBoltAbilityArgs;
let FrostAndFireBoltActorAbilityFactory = class FrostAndFireBoltActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("FrostAndFireBolt", "OneEnemies", 0);
    }
};
FrostAndFireBoltActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("FrostAndFireBolt")
], FrostAndFireBoltActorAbilityFactory);
exports.FrostAndFireBoltActorAbilityFactory = FrostAndFireBoltActorAbilityFactory;
let FrostAndFireBoltAbilityHandler = class FrostAndFireBoltAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "FrostFireBolt",
            projectilePath: "line",
            toApply: [
                // if this damage changes, be sure to update the Ability_Mirror_OnAbilityUsed event handler script as well.
                AbilityDamage_1.AbilityDamage.Focus("Frost", 25),
                AbilityDamage_1.AbilityDamage.Focus("Fire", 25),
            ],
            onHit(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy), "BlueVapor"));
            }
        });
    }
};
FrostAndFireBoltAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.FrostAndFireBolt)
], FrostAndFireBoltAbilityHandler);
exports.FrostAndFireBoltAbilityHandler = FrostAndFireBoltAbilityHandler;
